import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
import Spacer from '../spacer';
import Text from '../text';
import Button from '../button';
import useMobile from '../hooks/use-mobile';
import Modal from './modal';
const StyledContainer = styled.View`
  padding: ${props => props.mobile ? 20 : 24}px;
`;
export default function Prompt(props) {
  const mobile = useMobile();
  const StyledText = mobile ? Text.BodySmall : Text.BodyBase;
  return /*#__PURE__*/React.createElement(Modal, {
    active: props.active,
    activeSetter: props.activeSetter,
    width: mobile ? 300 : 327
  }, /*#__PURE__*/React.createElement(StyledContainer, {
    mobile: mobile
  }, /*#__PURE__*/React.createElement(Text.H5, {
    align: "center"
  }, props.title), /*#__PURE__*/React.createElement(Spacer, {
    size: mobile ? 'f4' : 'f8',
    height: true
  }), /*#__PURE__*/React.createElement(StyledText, {
    color: Colors.gray600,
    align: "center"
  }, props.description), /*#__PURE__*/React.createElement(Spacer, {
    size: "d32",
    height: true
  }), props.buttons.map((button, index) => {
    const isLast = props.buttons.length - 1 === index;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      type: button.type,
      onPress: button.onPress,
      width: "100%"
    }, button.name), !isLast && /*#__PURE__*/React.createElement(Spacer, {
      size: mobile ? 'f4' : 'f8',
      height: true
    }));
  })));
}
Prompt.defaultProps = {
  title: '',
  description: '',
  buttons: [{
    name: '',
    type: 'primary',
    onPress: () => {}
  }, {
    name: '',
    type: 'tertiary',
    onPress: () => {}
  }],
  active: true
};
Prompt.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    onPress: PropTypes.func
  })),
  active: PropTypes.bool,
  activeSetter: PropTypes.func.isRequired
};
//# sourceMappingURL=prompt.js.map